angular.module('controllers').controller('discountReasonController', ['$scope', '$rootScope', '$controller',
	function ($scope, $rootScope, $controller) {
		$rootScope.path = '/discount-reason';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'discount-reason';
		$scope.pathTemplate = 'discounts/discountreasons';
		$scope.title = 'Motive discount';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'discount_reason_name';
		$scope.defaultItem = 10;
		$rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'discount_reason_name':{'label':'Motiv reducere', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals = [];
		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'discount_reason_name';

		$scope.additionals['functionResult']= function(ev, data) {
			if (!angular.isUndefined($scope.modelData.discount_reason_name)) {
				$scope.modelData.discount_reason_name = $scope.modelData.discount_reason_name.toLowerCase();
			}
			if (!angular.isUndefined($scope.modelsData)) {
				angular.forEach($scope.modelsData, function (item, key) {
					if (!angular.isUndefined($scope.modelsData[key].discount_reason_name)) {
						$scope.modelsData[key].discount_reason_name = $scope.modelsData[key].discount_reason_name.toLowerCase();
					}
				});
			}
		}

		$scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);


	}]
);
